// extracted by mini-css-extract-plugin
module.exports = {"searchBar":"SearchBar_searchBar__e6xWh","form":"SearchBar_form__2-8f4"};